module.exports = __webpack_public_path__ + "img/r-144.22bf6052.jpg";